import { Table } from 'semantic-ui-react';
import Actions from '../Common/Actions';
import { useState } from 'react';
import Filters from '../Common/Filters';
import { getLocalTime, timestampColumns } from '../../utils';
import { useSelector } from 'react-redux';

const columnsToHide = ['Task', 'Enabled', 'createdAt', 'updatedAt', 'TaskId'];

const JobList = ({ jobs }) => {
  const timezone = useSelector((state: any) => state.auth.timezone);
  const useLocalTime = timezone === 'UTC' ? false : true;

  const [filteredJobs, setFilteredJobs] = useState(jobs);

  if (!jobs || jobs.length === 0) return <div>No Jobs</div>;

  return (
    <div>
      {jobs.length > 0 && (
        <Filters
          originalList={jobs}
          filteredLists={filteredJobs}
          allowedParams={[
            'ClientName',
            'ClientId',
            'TaskName',
            'id',
            'nextInvocationTime',
          ]}
          setFilteredLists={setFilteredJobs}
        />
      )}
      <Table>
        <Table.Header>
          <Table.Row>
            {Object.keys(jobs[0])
              .filter((elem) => !columnsToHide.includes(elem))
              .sort()
              .concat('Actions')
              .map((header) => {
                return (
                  <Table.HeaderCell key={header}>{header}</Table.HeaderCell>
                );
              })}
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {filteredJobs.map((job: any) => {
            return (
              <Table.Row key={job.id}>
                {Object.keys(job)
                  .filter((elem) => !columnsToHide.includes(elem))
                  .sort()
                  .map((elem: any) => {
                    return (
                      <Table.Cell key={`${elem}|${job.id}`}>
                        {timestampColumns.includes(elem) && useLocalTime
                          ? getLocalTime(job[elem])
                          : job[elem] === false
                          ? 'false'
                          : job[elem] && job[elem].toString()}
                      </Table.Cell>
                    );
                  })
                  .concat(
                    <Table.Cell key={`${job.id}-actions`}>
                      <Actions
                        showDetails
                        detailsLink={`/tasks/scheduled-task/${job.id}`}
                      />
                    </Table.Cell>
                  )}
              </Table.Row>
            );
          })}
        </Table.Body>
      </Table>
    </div>
  );
};

export default JobList;
